<template>
  <div class="fair-config-wrap">
    <h1>Fair Config</h1>
    <upload-media></upload-media>
    <div class="search">
      <label>Search</label>
      <input type="text" v-model.trim="search">
    </div>
    <div class="form-wrap">
      <div class="input-label" v-for="(input, label) in filteredConfig"
        :key="label"
      >
        <label>{{label}}</label>
        <input type="text" v-model="config[label]">
      </div>
    </div>
    <button @click="saveConfig">Save</button>
  </div>
</template>

<script>
import api from '@/api'
import AdminMixin from '@/views/admin-pages/adminMixin.js'
import UploadMedia from '@/components/admin/fair-config/UploadMedia'
export default {
  components: {
    UploadMedia
  },
  mixins: [
    AdminMixin
  ],
  data () {
    return {
      config: {},
      search: "",
    };
  },
  computed: {
    filteredConfig () {
      if (!this.search) return this.config;
      
      const filteredConfig = {};
      const filteredKeys = Object.keys(this.config).filter(key => key.toLowerCase().includes(this.search.toLowerCase()));
      for (let key of filteredKeys) {
        filteredConfig[key] = this.config[key];
      }
      return filteredConfig;
    },
  },
  mounted () {
    this.getConfig();
  },
  methods: {
    async getConfig () {
      try {
        this.startLoading();
        const res = await api.getFairConfig();
        this.config = res.data.data;
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    async saveConfig () {
      try {
        this.trimConfigObj();
        this.startLoading();
        await api.saveConfig({
          data: this.config
        });
        this.showSuccessMessage('Fair Config updated.');
      } catch (error) {
        this.handleError(error);
      }
      this.stopLoading();
    },
    trimConfigObj () {
      for (const key in this.config) {
        if (typeof this.config[key] === 'string') this.config[key] = this.config[key].trim();
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.fair-config-wrap {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1% 10% 1% 3%;
  font-size: 18px;
}
.form-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60%;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
}
.input-label {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 2px 0;
}
.input-label input{
  width: 50%;
}
button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
}
</style>